import { render, staticRenderFns } from "./RoomInformation.vue?vue&type=template&id=24e95e8c&scoped=true&"
import script from "./RoomInformation.vue?vue&type=script&lang=ts&"
export * from "./RoomInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e95e8c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e95e8c')) {
      api.createRecord('24e95e8c', component.options)
    } else {
      api.reload('24e95e8c', component.options)
    }
    module.hot.accept("./RoomInformation.vue?vue&type=template&id=24e95e8c&scoped=true&", function () {
      api.rerender('24e95e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/rooms/RoomInformation.vue"
export default component.exports